import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_of_loss_filter_btn = _resolveComponent("date-of-loss-filter-btn")!
  const _component_date_range_picker_btn = _resolveComponent("date-range-picker-btn")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_component_q_btn_group, { rounded: "" }, {
    default: _withCtx(() => [
      (_ctx.isGranted('VIEW_LEGAL_PHRASES'))
        ? (_openBlock(), _createBlock(_component_date_of_loss_filter_btn, {
            key: 0,
            "client-id": _ctx.clientId,
            "date-of-loss": _ctx.dateOfLoss,
            "model-value": _ctx.modelValue,
            filters: _ctx.filters,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
          }, null, 8, ["client-id", "date-of-loss", "model-value", "filters"]))
        : _createCommentVNode("", true),
      (_ctx.isGranted('VIEW_LEGAL_PHRASES'))
        ? (_openBlock(), _createBlock(_component_date_of_loss_filter_btn, {
            key: 1,
            "client-id": _ctx.clientId,
            "date-of-loss": _ctx.dateOfLoss,
            "model-value": _ctx.modelValue,
            filters: _ctx.filters,
            "post-date-of-loss": "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
          }, null, 8, ["client-id", "date-of-loss", "model-value", "filters"]))
        : _createCommentVNode("", true),
      _createVNode(_component_date_range_picker_btn, {
        label: _ctx.customLabel,
        "model-value": _ctx.modelValue,
        color: _ctx.customColor,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
        ref: "dateRangePickerBtn"
      }, null, 8, ["label", "model-value", "color"]),
      (_ctx.hasValue)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 2,
            icon: "fa fa-times",
            onClick: _ctx.clear
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}